import { TypeScienceBehindFields } from '@/core/generated-types';
import React, { FC } from 'react';

export const ScienceBehind: FC<TypeScienceBehindFields> = ({
  title,
  item1Heading,
  item1Label,
}) => {
  return (
    <div className="bg-blue-tint">
      <div className="max-w-[1220px] mx-auto w-full lg:flex lg:items-center px-6 lg:px-6 lg:h-[400px] pt-8 lg:pt-0">
        <div className="flex-col lg:w-[50%]">
          <p className="font-sans text-[32px] lg:text-[45px] font-bold leading-[42px] lg:max-w-[475px] lg:leading-[3.25rem] mb-6">
            {title}
          </p>
        </div>
        <div className="flex flex-col lg:w-[50%] justify-between gap-6 lg:gap-12">
          <div
            key={item1Label}
            className={`flex items-start lg:items-end justify-start pb-8 lg:pb-0`}
          >
            <p className="text-5xl leading-[60px] lg:text-[68px] font-bold mr-8 lg:mr-10 min-w-[80px] w-[100px] lg:min-w-[150px] lg:w-[150px]">
              {item1Heading}
            </p>
            <p className="text-[18px] lg:text-[20px] font-normal lg:w-[374px]">
              {item1Label}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScienceBehind;
